module.exports = __webpack_public_path__ + "media/application/images/icons/strong-relationship-35aecc4f36932d9888937c1d542fc701.svg";